import { render } from "./CollapseBar.vue?vue&type=template&id=889bf270"
import script from "./CollapseBar.vue?vue&type=script&lang=js"
export * from "./CollapseBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__